export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  All = 'all',
}
